import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { studyEDCLupReportingServices } from "../../../APIServices/studyEDCLupReportingServices";

const UpdateReportData = ({ Show, Hide, Title, reportData, setReportData, setReportId, getEDCLupReportList }) => {
  let { studyId } = useParams();
  const [reportName, setReportName] = useState("");
  const [reportLabel, setReportLabel] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const updateDataLibraryFileAndDataset = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Report!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {}
        userData.id = reportData?._id
        userData.uniqueId = reportData?.uniqueId
        userData.name = reportName
        userData.label = reportLabel
        userData.studyId = studyId
        userData.mode = StudyMode;
        let data = await studyEDCLupReportingServices.updateDataLibraryFileAndDataset(userData);
        if (data?.statusCode === 200) {
          getEDCLupReportList();
          setReportData("")
          setReportId("")
          Hide()
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setReportName(reportData?.name);
    setReportLabel(reportData?.label);
  }, [reportData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Report Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              className="fontSize12"
              placeholder="Enter Report"
              onChange={(e) => setReportName(e.target.value)}
              value={reportName}
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="mb-1 fw-bold">
              Report Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              type="text"
              className="fontSize12"
              placeholder="Enter Report"
              onChange={(e) => setReportLabel(e.target.value)}
              value={reportLabel}
            />
          </Form.Group>
        </Offcanvas.Body>
        <div className="text-end p-2 border-top">
          <button
            onClick={updateDataLibraryFileAndDataset}
            disabled={!reportName || !reportLabel || buttonLoader}
            title={Title}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Report"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateReportData;
